import { css, useTheme } from '@emotion/react';

import { styledComponents, textStyles } from './styles';
import { boxStyles } from '../Box';

import type { ElementType, FC, HTMLAttributes } from 'react';
import type { TextStypeProps } from './styles';
import type { BoxStylingProps } from '../Box';

export type TypographyProps = HTMLAttributes<HTMLHeadingElement> &
  BoxStylingProps &
  TextStypeProps & {
    variant?: keyof typeof styledComponents;
    as?: ElementType;
  };

export const Typography: FC<TypographyProps> = ({
  variant = 'b1',
  color,
  fontWeight,
  fontSize,
  fontFamily,
  lineHeight,
  ...props
}) => {
  const theme = useTheme();
  const Component = styledComponents[variant];
  return (
    <Component
      {...props}
      css={css`
        ${boxStyles(props)(theme)}
        ${textStyles({ color, fontFamily, fontSize, fontWeight, lineHeight })}
      `}
    />
  );
};
